"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

require("./FooterEmailCapture.css");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var FooterEmailCapture = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(FooterEmailCapture, _React$PureComponent);

  var _super = _createSuper(FooterEmailCapture);

  function FooterEmailCapture() {
    (0, _classCallCheck2["default"])(this, FooterEmailCapture);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(FooterEmailCapture, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          submitForm = _this$props.submitForm,
          updateFormFields = _this$props.updateFormFields,
          formFieldValues = _this$props.formFieldValues,
          isSuccess = _this$props.isSuccess;
      return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form, {
        size: "tiny",
        onSubmit: submitForm,
        success: isSuccess
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Field, null, /*#__PURE__*/_react["default"].createElement("label", null, "Subscribe for updates"), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Input, {
        action: {
          primary: true,
          icon: 'send',
          type: 'submit'
        },
        onChange: function onChange(e) {
          return updateFormFields('email', e);
        },
        placeholder: "Your Email",
        required: true,
        type: "email",
        value: formFieldValues.email
      })), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Message, {
        success: true,
        header: "Subscribed!"
      }));
    }
  }]);
  return FooterEmailCapture;
}(_react["default"].PureComponent);

var _default = FooterEmailCapture;
exports["default"] = _default;